import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";

const StickerTypeChange = ({ stickerType, po, onSuccess  }) => {

  const [showSave, setShowSave] = useState(false);
  const [newStickerType, setnewStickerType] = useState(stickerType || "");
  const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     setnewStickerType((stickerType || "").trim().toUpperCase());
  //   }, [stickerType]);

  //   const handleInputChange = (e) => {
  //     setnewStickerType(e.target.value.trim().toUpperCase());
  //   };

  const handleEdit = () => {
    setShowSave(true);
  };

  const handleSubmit = async () => {
    if(newStickerType === stickerType) {
      toast.remove();
      return toast.error("You can not change the same sticker type. Please change");
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      // icon: 'warning',
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    });
    if (result.isConfirmed) {
      setLoading(true);
      // http://localhost:5100/api/v1/entry/changeStickerType?PO=703008&STYP=MOGSTKTEO
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_LINK}/api/v1/entry/changeStickerType?PO=${po}&STYP=${stickerType}`
        );
        console.log("response check", response);
        if (response.data.success) {
          onSuccess?.();
        }
        // setnewStickerType(newStickerType);
        Swal.fire("Success!", "new sticker updated.", "success");
      } catch (error) {
        // setnewStickerType(stickerType);
        console.error("error:", error);
        const errorMessage =
          error?.response?.data?.message || "Something went wrong";
        Swal.fire("Error", errorMessage, "error");
      } finally {
        setShowSave(false);
        setLoading(false);
      }
    }
  };

  return (
    <td>
      <div className="d-flex align-items-center gap-2">
        <select
          value={newStickerType}
          disabled={!showSave}
          onChange={(e) => setnewStickerType(e.target.value)}
          className="form-select form-select-sm"
          style={{ width: "145px" }}
        >
          <option value={stickerType}>{stickerType || "LERROS"}</option>

          {stickerType && <option value="">LERROS</option>}
        </select>
        <button
          onClick={showSave === false ? handleEdit : handleSubmit}
          className={
            showSave === false
              ? "btn btn-sm btn-primary"
              : "btn btn-sm btn-success"
          }
          style={{ width: "43px" }}
          disabled={loading || stickerType === ""}
        >
          {showSave === false ? (
            "Edit"
          ) : loading ? (
            <Spinner size="sm" />
          ) : (
            "Save"
          )}
        </button>
      </div>
    </td>
  );
};
export default StickerTypeChange;
